import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelAmenitiesArea as t } from "../level-metrics/index.js";
const o = (e) => r(e, t);
export {
  o as getLevelArrayAmenitiesArea
};
//# sourceMappingURL=index.js.map
